var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 171,
    viewBox: "0 0 194 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_37",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 171
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 171,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_37)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_125_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.741 40.3032C113.499 40.3032 115.185 41.0017 116.429 42.245C117.672 43.4883 118.37 45.1745 118.37 46.9328V126.488C118.37 128.246 117.672 129.933 116.429 131.176C115.185 132.419 113.499 133.118 111.741 133.118H71.9631C70.2048 133.118 68.5185 132.419 67.2752 131.176C66.0319 129.933 65.3335 128.246 65.3335 126.488V46.9328C65.3335 45.1745 66.0319 43.4883 67.2752 42.245C68.5185 41.0017 70.2048 40.3032 71.9631 40.3032H111.741ZM71.9631 33.6736C68.4465 33.6736 65.074 35.0705 62.5874 37.5571C60.1008 40.0437 58.7039 43.4162 58.7039 46.9328V126.488C58.7039 130.005 60.1008 133.377 62.5874 135.864C65.074 138.35 68.4465 139.747 71.9631 139.747H111.741C115.257 139.747 118.63 138.35 121.116 135.864C123.603 133.377 125 130.005 125 126.488V46.9328C125 43.4162 123.603 40.0437 121.116 37.5571C118.63 35.0705 115.257 33.6736 111.741 33.6736H71.9631Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_125_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.852 126.488C93.6103 126.488 95.2966 125.79 96.5399 124.547C97.7832 123.303 98.4816 121.617 98.4816 119.859C98.4816 118.101 97.7832 116.414 96.5399 115.171C95.2966 113.928 93.6103 113.229 91.852 113.229C90.0937 113.229 88.4075 113.928 87.1642 115.171C85.9209 116.414 85.2224 118.101 85.2224 119.859C85.2224 121.617 85.9209 123.303 87.1642 124.547C88.4075 125.79 90.0937 126.488 91.852 126.488Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.05 15.5622C124.745 15.5622 127.33 16.6329 129.236 18.5387C131.142 20.4446 132.212 23.0294 132.212 25.7247V147.675C132.212 150.37 131.142 152.955 129.236 154.861C127.33 156.767 124.745 157.838 122.05 157.838H61.0748C58.3795 157.838 55.7947 156.767 53.8888 154.861C51.983 152.955 50.9123 150.37 50.9123 147.675V25.7247C50.9123 23.0294 51.983 20.4446 53.8888 18.5387C55.7947 16.6329 58.3795 15.5622 61.0748 15.5622H122.05ZM61.0748 5.39966C55.6843 5.39966 50.5145 7.54104 46.7028 11.3527C42.8911 15.1644 40.7498 20.3342 40.7498 25.7247V147.675C40.7498 153.066 42.8911 158.235 46.7028 162.047C50.5145 165.859 55.6843 168 61.0748 168H122.05C127.44 168 132.61 165.859 136.422 162.047C140.234 158.235 142.375 153.066 142.375 147.675V25.7247C142.375 20.3342 140.234 15.1644 136.422 11.3527C132.61 7.54104 127.44 5.39966 122.05 5.39966L61.0748 5.39966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.681 150.901C94.6215 150.901 97.4417 149.733 99.521 147.653C101.6 145.574 102.768 142.754 102.768 139.813C102.768 136.873 101.6 134.053 99.521 131.973C97.4417 129.894 94.6215 128.726 91.681 128.726C88.7404 128.726 85.9202 129.894 83.8409 131.973C81.7616 134.053 80.5935 136.873 80.5935 139.813C80.5935 142.754 81.7616 145.574 83.8409 147.653C85.9202 149.733 88.7404 150.901 91.681 150.901Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_125_37",
    x: 16.9828,
    y: -8.04749,
    width: 149.738,
    height: 189.516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.98008
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_125_37",
    result: "effect2_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4303
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_125_37",
    result: "effect3_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.8605
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_125_37",
    result: "effect4_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_125_37",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_125_37",
    x: 80.0073,
    y: 108.014,
    width: 23.6895,
    height: 23.6895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.186255
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.37251
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_125_37",
    result: "effect2_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30378
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_125_37",
    result: "effect3_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.60757
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.984314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_125_37",
    result: "effect4_dropShadow_125_37"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_125_37",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.02bf66faeae1a65ee6fb81484c7d63f1.svg";
export { ForwardRef as ReactComponent };